"use strict";
var PackageAgreement = (function () {
    function PackageAgreement() {
    }
    return PackageAgreement;
}());
exports.PackageAgreement = PackageAgreement;
//# sourceMappingURL=D:/a/1/s/purchase/src/models/licensing/package-agreement.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/purchase/src/models/licensing/package-agreement.model.js